<template>
  <b-modal ref="edit-lb" hide-footer @hide="hideEditLBModal">
    <div class="d-block text-center">
      <h4 qid="add-lb-title">
        {{ $t('processes.legal_basis.edit.title') }}
      </h4>
    </div>
    <b-alert v-if="error.length"
             show
             variant="danger"
             qid="create-lb-error"
    >
      {{ error }}
    </b-alert>
    <b-form @submit="formSubmit" qid="create-lb-form">
      <div class="form-container">
        <b-form-group>
          <label qid="create-lb-pg-label">
            {{ $t('processes.legal_basis.create.article_label') }}
          </label>
          <multiselect
              v-model="selectedArticle"
              :options="articles"
              :placeholder="$t('processes.legal_basis.create.article_placeholder')"
              label="name_modified"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              track-by="slug"
              @select="addLocalName"
              @remove="removeLocalName"
              qid="create-lb-form-pg"
          ></multiselect>
        </b-form-group>
        <div v-if="selectedArticle && selectedArticle.description"
             class="text-center mb-3 mt-4"
        >
          <span class="cursor-pointer">
            <span class="mr-2"
                  @click="showArticleDescription = !showArticleDescription"
                  qid="expand-legal-basis-description"
            >
              {{ $t('processes.legal_basis.view.description_expand') }}
            </span>
            <font-awesome-icon icon="chevron-down" v-if="!showArticleDescription"/>
            <font-awesome-icon icon="chevron-up" v-if="showArticleDescription"/>
          </span>
        </div>
        <div v-if="selectedArticle && selectedArticle.description && showArticleDescription"
             class="mb-4 mt-2"
        >
          <span class="text-formatted">
            {{ selectedArticle.description }}
          </span>
        </div>
        <b-form-group>
          <label qid="create-lb-name-label">
            {{ $t('processes.legal_basis.create.name_label') }}
          </label>
          <b-form-input
            qid="create-lb-form-name"
            type="text"
            v-model="lbForm.name"
            :placeholder="$t('processes.legal_basis.create.name_placeholder')"
          ></b-form-input>
        </b-form-group>
        <b-form-group>
          <label qid="create-lb-description-label">
            {{ $t('processes.legal_basis.create.reason_label') }}
          </label>
          <b-form-textarea
            qid="create-lb-form-description"
            v-model="lbForm.article_reason"
            rows="6"
            max-rows="6"
            :placeholder="$t('processes.legal_basis.create.reason_placeholder')"
          ></b-form-textarea>
        </b-form-group>

      </div>
      <div class="text-right">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideEditLBModal"
                  qid="create-lb-cancel-button"
        >
          {{ $t('processes.legal_basis.create.cancel') }}
        </b-button>
        <b-button type="submit"
                  class="mt-3 ml-3"
                  variant="success"
                  :disabled="buttonDisabled"
                  qid="create-lb-submit-button"
        >
          <span v-if="buttonDisabled" class="mr-1">
            <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
          </span>
          {{ $t('processes.legal_basis.create.submit') }}
        </b-button>
      </div>
    </b-form>
  </b-modal>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'LegalBasisEditModal',
    data: function() {
      return {
        lbForm: {
          name: '',
          article_reason: '',
          article_id: ''
        },
        selectedArticle: [],
        error: '',
        loadingItems: false,
        showArticleDescription: false,
        buttonDisabled: false
      }
    },
    props: {
      object: {
        type: Object
      },
      articles: {
        type: Array
      },
      process: {
        type: Object
      },
      showModal: {
        type: Boolean
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showEditLBModal()
        }
      }
    },
    methods: {
      showEditLBModal() {
        let self = this;

        this.selectedArticle = this.object.article
        this.selectedArticle.name_modified = this.selectedArticle.name + ' (' + this.selectedArticle.short_name + ' )'
        this.lbForm.name = this.object.name
        this.lbForm.article_reason = this.object.article_reason

        this.$refs['edit-lb'].show()
      },
      hideEditLBModal() {
        this.error = ''
        this.$emit('closeEditModal');
        this.$refs['edit-lb'].hide()
      },
      addLocalName(item) {
        this.lbForm.name = item.short_name;
      },
      removeLocalName(item) {
        this.lbForm.name = ''
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedArticle) {
          this.lbForm.article_id = this.selectedArticle.id;
        }

        piincHttp.put('processes/' + this.process.slug + '/legal-basis/' + this.object.id, this.lbForm).then(function() {
          self.hideEditLBModal();
          self.buttonDisabled = false;
          self.$toastr('success', self.$t('processes.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.article_id) {
              self.error += ' ' + error.data.errors.article_id[0]
            }
          }
        })
      }
    },
    components: {

    },
    created () {

    }
  }
</script>
